module.exports = __webpack_public_path__ + "static/media/IOTX.234b5a86.svg";